import React from "react";

function AdvantageCard({ title, description, image, alt, style }) {
  return (
    <div className={`flex-1 p-4 rounded-[28px] border-2 border-[--color-primary] ${style} flex`}>
      <div
        className="bg-white border border-[#D1E7ED] rounded-3xl flex flex-col justify-between items-center w-full min-h-[500px] h-[500px] px-8 py-10"
      >
        <div className="flex-1 flex flex-col items-center justify-start w-full">
          <h3 className="text-3xl font-bold mb-2 text-center">{title}</h3>
          <div className="text-gray-700 text-center mb-6">{description}</div>
        </div>
        <div className="flex-shrink-0 flex items-end w-full justify-center">
          <img
            src={image}
            alt={alt}
            className="mb-2 w-[120px] h-[120px] object-contain"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
}

export default AdvantageCard;